import { cn } from "@workspace/ui/lib/utils"

type LogoProps = {
  /** Drop the product half — renders just "Blumen". */
  wordmarkOnly?: boolean
  className?: string
}

export function Logo({ wordmarkOnly = false, className }: LogoProps) {
  return (
    <a
      href="/"
      aria-label="Blumen Solutions — home"
      className={cn(
        "group inline-flex items-center gap-2.5 text-[13px] leading-none font-semibold tracking-tight text-foreground transition-colors hover:text-primary",
        className,
      )}
    >
      <img
        src="/BlumenLogo.svg"
        alt=""
        aria-hidden
        className={cn(
          "size-7 shrink-0 transition-transform duration-500 group-hover:rotate-12",
        )}
      />
      {!wordmarkOnly && (
        <span className="font-mono text-[11px] uppercase tracking-[0.22em]">
          Blumen<span className="text-foreground/35">/</span>Solutions
        </span>
      )}
    </a>
  )
}
